import dayjs from 'dayjs';
import React, { useState, useEffect } from 'react';
import { DataTable, Filter, PageWrapper } from '../../components';
import { getAuditList } from "../../api/audit";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DATETIME_FORMAT } from '../../shared/constants';
import { Button, Modal, Table } from 'react-bootstrap';

const Audit = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);

    const columns = [
        { key: "author", label: t("AUTHOR"), },
        { key: "entityType", label: t("ENTITY_TYPE") },
        { key: "activity", label: t("ACTIVITY") },
        { key: "createdAt", label: t("CREATED_AT"), render: (createdAt, data) => dayjs(createdAt).format(DATETIME_FORMAT), },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Button className="me-3" size={"sm"} onClick={() => {
                setSelected(data);
            }}>
                {t("VIEW")}
            </Button>
        }
    ]

    const filters = [
        { type: "input", label: t("SEARCH"), name: "search" },
    ]

    useEffect(() => {
        getData(pagination, filter)
    }, [pagination, filter])

    const getData = async (pagination, filter) => {
        const response = await getAuditList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    const generateDiff = (data) => {
        if (!data) return null;

        const genDataContent = (nestedData, isNested = false) => {
            if (typeof nestedData === 'object') {
                if (Array.isArray(nestedData)) {
                    if (nestedData.length === 0) return '[]';
                    return nestedData.map((e, idx) => (
                        <div key={e + idx} style={{ "margin-left": isNested ? 16 : 0 }}>
                            {genDataContent(e, true)}
                        </div>
                    ));
                } else {
                    const keys = Object.keys(nestedData);
                    return keys?.map((e, idx) => (
                        <>
                            <div style={{ "margin-left": isNested ? 16 : 0 }} key={e + idx}>
                                <u><strong>{e}</strong></u>
                                <br />
                                {genDataContent(nestedData?.[e], true)}
                            </div>
                            <br />
                        </>
                    ));
                }
            } else if (typeof nestedData === 'boolean') {
                return nestedData ? `"true"` : `"false"`;
            } else {
                return `"${nestedData}"`;
            }
        }


        if (data.activity === 'CREATE') {
            return genDataContent(data?.after);
        } else if (data.activity === 'UPDATE') {
            return (data?.differences?.length ?? 0) > 0 ? (
                data?.differences?.map((e, idx) => (
                    <>
                        <div key={e + idx}>
                            <u><strong>{e}</strong></u>
                            <br />
                            <span style={{ color: "#888" }}>{genDataContent(data?.before?.[e])}</span>
                            <span> &rarr; </span>
                            <span>{genDataContent(data?.after?.[e])}</span>
                        </div>
                        <br />
                    </>
                ))
            ) : (
                'No changes'
            )
        }
    }

    return (
        <PageWrapper
            headerProps={{
                title: "AUDIT",
            }}
        >
            <Filter filters={filters} onChangeFilter={setFilter} />
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />

            <Modal show={selected} onHide={() => setSelected(null)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{t("AUDIT_DETAILS")}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "76vh", overflow: "auto" }}>
                    <Table bordered className="mt-4">
                        <tbody>
                            <tr>
                                <td width="30%"><strong>{t("AUTHOR")}</strong></td>
                                <td>{selected?.author}</td>
                            </tr>
                            <tr>
                                <td><strong>{t("ACTIVITY")}</strong></td>
                                <td>{selected?.activity}</td>
                            </tr>
                            <tr>
                                <td><strong>{t("ENTITY_TYPE")}</strong></td>
                                <td>{selected?.entityType}</td>
                            </tr>
                            <tr>
                                <td><strong>{t("CREATED_AT")}</strong></td>
                                <td>{dayjs(selected?.createdAt).format(DATETIME_FORMAT)}</td>
                            </tr>
                            <tr>
                                <td><strong>{t("ENTITY_ID")}</strong></td>
                                <td>{selected?.entityId}</td>
                            </tr>
                            <tr>
                                <td><strong>{t("DIFFERENCES")}</strong></td>
                                <td>
                                    {generateDiff(selected)}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </PageWrapper>
    );
};

export default Audit;
